import { IState } from '../state/store.state';

export const getAppNameSelector = (state: IState): string => state.layout.appName;

export const isDesktopModeSelector = (state: IState): boolean => state.layout.isDesktopMode;
